import { LabelChoice } from '@scale/shared/types/params/annotation';
import _ from 'lodash';
import React from 'react';
import { Select, Option } from 'react-scale/components/design-system/Select';
import HintTooltipIcon from '../../tasks/textcollection/HintTooltipIcon';

interface AttributeMultiSelectProps {
  choices: LabelChoice[];
  selectedChoice?: string[];
  handleSelect: (choices: string[]) => void;
  isReadOnly?: boolean;
}

export const AttributeMultiSelect: React.FC<AttributeMultiSelectProps> = ({
  choices,
  selectedChoice,
  handleSelect,
  isReadOnly,
}) => {
  // only handle change if field isn't marked as readOnly
  const onChange = (e: React.ChangeEvent<{ value: string[] }>) => {
    !isReadOnly && handleSelect(e.target.value);
  };

  return (
    <Select multiple={true} value={selectedChoice ?? []} onChange={onChange}>
      {choices.map(choice => {
        let choiceValue: string;
        let choiceDisplay: string;
        let choiceHint: string | undefined;
        if (_.isString(choice)) {
          choiceValue = choice;
          choiceDisplay = choice;
          choiceHint = undefined;
        } else {
          choiceValue = choice.choice;
          choiceDisplay = choice.display || choice.choice;
          choiceHint = choice.hint;
        }

        return (
          <Option value={choiceValue} key={choiceValue}>
            {choiceDisplay}
            {choiceHint && <HintTooltipIcon key={choiceValue} hint={choiceHint} />}
          </Option>
        );
      })}
    </Select>
  );
};
